module.exports = "<div class=\"col-md-8 col-xs-12\"> <span> {%= dosTime.dosStartTime %} - {%= dosTime.dosEndTime %} </span> <br/> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/dockConfigurations/html/dockConfigNewEdit/html/dockShiftTime.html
// module id = 1267
// module chunks = 1